module.exports = __webpack_public_path__ + "img/logo-instagram.7a89bf3f.svg";